import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useQuery } from "react-query";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button } from "../../components/Button";
import { Loader } from "../../components/Loader";
import { Table } from "../../components/Table";
// import logo from "../../images/singleLogo.png";
import { GenerateRestaurantReport } from "../../components/models/GenerateRestaurantReport";

export const Branches: React.FC = () => {
  const { restId } = useParams();
  const navigate = useNavigate();
  const [restaurant, setRestaurant] = useState<any>({});

  const { data, isLoading, refetch } = useQuery("Get Branches", async () => {
    const response = await axios.get(`/restaurant/branches/${restId}`);
    setRestaurant(response.data?.branches[0]?.restaurant);
    return response.data.branches.map((el: any, index: number) => ({
      id: index + 1,
      name: el.name,
      branch_id: el.branch_id,
      actions: (
        <div className="flex gap-2">
          <GenerateRestaurantReport
            restaurantId={el?.restaurant?.id}
            branchId={el.id}
            type="branch"
          />

          <Link to={`/dashboard/restaurants/devices/${restId}/${el.id}`}>
            <Button lightGreen>Devices</Button>
          </Link>
          <Button lightBlue onClick={() => downloadQRCode(el.Devices)}>
            Print QR's
          </Button>
        </div>
      ),
      qr: el.Devices.map((device: any) => {
        return (
          <QRCodeCanvas
            key={device.id}
            id={device.id}
            className="hidden"
            value={`{"1": "${restId}", "2": "${device.device_id}", "3": "${
              process.env.REACT_APP_WEB_INVOICE_URL as string
            }?restId=${restId}&deviceId=${device.device_id}"}`}
            // imageSettings={imageSettings}
            fgColor={"#000000"}
            bgColor={"#FFFFFF"}
            level={"H"}
            size={255}
            includeMargin={true}
          />
        );
      }),
    }));
  });

  // const imageSettings = {
  //   src: logo,
  //   excavate: true,
  //   height: 40,
  //   width: 40,
  // };

  const downloadQRCode = (devices: any) => {
    if (devices.length > 0) {
      // eslint-disable-next-line array-callback-return
      devices.map((device: any) => {
        const canvas = document.getElementById(device.id) as any;
        const pngUrl = canvas
          ?.toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = `${device.name} - ${device.device_id}.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "id",
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "",
        accessor: "actions",
      },
      {
        Header: "",
        accessor: "qr",
      },
    ],
    []
  );

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading)
    return (
      <div className="flex justify-center items-center pt-32">
        <Loader />
      </div>
    );

  return (
    <div>
      <header className="my-3 flex items-center gap-4">
        <Button
          lightRed
          className="h-fit"
          onClick={() => navigate("/dashboard/restaurants")}
        >
          Back
        </Button>
        <h3 className="text-2xl font-medium py-4">
          {restaurant?.name} Branches
        </h3>
      </header>
      {data.length === 0 && !isLoading && (
        <div>Restaurants doesn't Contain Branches</div>
      )}
      {data.length > 0 && <Table columns={columns} data={data} filter={true} />}
    </div>
  );
};
